import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function NotFound() {
  useEffect(() => {
    document.title = "404 — Ballah Code";
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground font-sans flex flex-col">
      {/* Nav */}
      <nav className="flex items-center justify-between px-8 py-[18px]">
        <Link
          to="/"
          className="text-sm font-semibold tracking-[-0.03em] text-zinc-200 hover:text-white transition-colors"
        >
          ballah code
        </Link>
        <div className="flex items-center gap-6 text-[13px] text-zinc-600">
          <Link to="/tools" className="hover:text-zinc-400 transition-colors">
            tools
          </Link>
          <Link to="/" className="hover:text-zinc-400 transition-colors">
            home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-8 pb-24">
        <p className="text-[13px] text-zinc-700 font-mono mb-4">404</p>
        <h1 className="text-3xl font-medium tracking-[-0.03em] mb-3 text-zinc-200">
          Page not found
        </h1>
        <p className="text-zinc-600 text-[15px] mb-8">
          This page doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="py-2.5 px-5 rounded-[10px] border border-white/[0.08] bg-white/[0.03] text-zinc-300 hover:bg-white/[0.06] hover:text-zinc-200 transition-colors flex items-center gap-2 text-[13px]"
        >
          <ArrowLeft size={14} /> Back to home
        </Link>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/[0.04] py-5 px-8 flex justify-between max-w-[1060px] mx-auto w-full text-xs text-zinc-800">
        <Link to="/" className="hover:text-zinc-600 transition-colors">
          ballah code
        </Link>
        <span>ballah tech</span>
      </footer>
    </div>
  );
}
